


























import { Component, Prop, Vue } from "vue-property-decorator";
import { IFilm } from "@/@types/cinema/films";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";

import CinemaList from "@/components/tables/cinema/cinema-list.vue";
import MovieCategorys from "@/components/tables/cinema/categorys/movie-categorys.vue";

@Component({
  components: { CinemaList, MovieCategorys },
})
class CinemaListPage extends Vue {
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: Boolean, default: false }) deletedCat!: boolean;
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<ICat>;
  @Prop({ type: Array, default: () => [] }) cinemaList!: Array<IFilm>;
  @Prop({ type: String, default: "" }) activeCategory!: string;

  updateMovie(id: string, data: Partial<IFilm>): void {
    this.$emit("updateMovie", id, data);
  }

  updateCategory(data: Partial<ICat>, id: string): void {
    this.$emit("updateCategory", data, id);
  }
}
export default CinemaListPage;
